<section>
  <p class="otp-p bold" i18n>Телефон:</p>
  <a target="_blank" href="tel: 070010375" class="otp-p light" i18n>0700 10 375 / *2375</a>
</section>
<section>
  <p class="otp-p bold" i18n>Aдрес:</p>
  <p class="otp-p light" i18n>Московска No.19 / ул. Г. Бенковски No. 5, София 1036</p>
</section>
<section>
  <p class="otp-p bold" i18n>SWIFT/BIC:</p>
  <p class="otp-p light" i18n>BIC/SWIFT на Банка ДСК: STSABGSF</p>
</section>
